import * as yup from 'yup';

export const DER_KEY={
    DEVICE :'deviceType',
    ENERGY:'energyType',
    ESD_G:'esdGen',
    CAPACITY:'capacity'
}

export const initialValues = {
    [DER_KEY.DEVICE]:'',
    [DER_KEY.ENERGY]: '',
    [DER_KEY.ESD_G]: '',
    [DER_KEY.CAPACITY]: '',
  };

export const ValidationSchema = yup.object().shape({
    [DER_KEY.DEVICE]:yup.string().required('Required'),
    [DER_KEY.CAPACITY]:yup.string().required('Required'),
    [DER_KEY.ENERGY]: yup.string().when([DER_KEY.DEVICE], {
      is: (value) => !!value,
      then: () => yup.string().required('Required'),
    }),
    [DER_KEY.ESD_G]: yup.string().when([DER_KEY.ENERGY], {
      is: (value) => !!value,
      then: () => yup.string().required('Required'),
    })
});
  